<template>
	<div
		:id="`self-service-${_uid}`"
		:class="[
			'c-block-list-self-service-custom',
			'w-5col >=768:w-6col max-w-full mx-auto',

			{
				'c-block-list-self-service-custom--wide': isWide,
				'c-block-list-self-service-custom--solid': isWide,
			},
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`self-service-${_uid}`"
			:title="title"
			:disabled="Boolean(accordionNestingLevel)"
		>
			<BaseH2 class="text-primary-button mb-sm" v-text="title" />
		</LongReadTarget>

		<div
			:class="[
				'c-block-list-self-service-custom__cards',
				'grid gap-x-layout-gutter gap-y-md >=1024:gap-y-sm grid-cols-1 >=1024:grid-cols-2',
			]"
		>
			<ContentCard
				v-for="card in selfServices"
				:id="`selfservice-${_uid}-${card.id}`"
				:key="card.key"
				:name="card.name"
				:to="card.url"
				:target="card.target"
				:light="isWide"
			>
				<template #before>
					<span
						v-text="
							destructureCategories(card.selfServiceCategories)
						"
					></span>
				</template>
			</ContentCard>
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import ContentCard from '~/components/shared/ContentCard';

export default {
	name: 'BlockListSelfServiceCustom',
	components: { LongReadTarget, ContentCard },

	inject: {
		accordionNestingLevel: {
			default: null,
		},
	},

	inheritAttrs: false,

	props: {
		selfServices: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			required: false,
		},
		wide: {
			type: Boolean,
			default: null,
		},
	},

	data() {
		const { template } = this.$store.state;
		return { isWide: this.wide ?? template === 'SubjectPage' };
	},

	methods: {
		destructureCategories(array) {
			if (array) {
				return array.map((x) => x.name).join(', ');
			} else {
				return '';
			}
		},
	},
};
</script>

<style lang="postcss">
.c-block-list-self-service-custom--wide {
	@apply max-w-layout-max w-screen !important;
	@apply -mx-layout-margin px-layout-margin !important;
	@apply bg-primary py-lg;
}
.c-block-list-self-service-custom--wide:first-child {
	@apply mt-0 pt-0 pb-xl;
}
.c-block-list-self-service-custom--wide
	.c-block-list-self-service-custom__cards {
	@apply >=1024:grid-cols-3 !important;
}
</style>
